import React from 'react';
import { useCollapse } from 'react-collapsed';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { dashboardSupportedQueryTypes } from '../../../utils/constants';
import { queryTypeConfigLookup } from '../../../../../utils/queryTypeLookup';
import { SvgIcon } from '../../../../../components/Icon';
import { useAppDispatch } from '../../../../../redux/hooks';
import { setCreateNewReport } from '../../../../../redux/slices/cachedEntities';
import { theme } from '../../../../../styles/theme';
import { SingleSelectOption } from '../../../../../components/Dropdown/SingleSelect';

interface IProps {
  baseId: string;
  disabled?: boolean;
}

const SectionTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 7px 8px;
  font-size: 12px;
  font-weight: 400;
  color: ${theme.colors.secondary800};
  outline: none;
  &:hover {
    color: ${theme.colors.mainBlue};
    cursor: pointer;
  }
`;
const StyledOption = styled(SingleSelectOption)`
  border-radius: 0 !important;
`;

const DashboardAddContentQueryTypes = ({ baseId, disabled }: IProps) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { getCollapseProps, getToggleProps, isExpanded } = useCollapse({
    defaultExpanded: false,
  });

  const handleQueryTypeClick = (url: string) => {
    // KBT-243. Preselect dashboardBaseId in Add to Dashboard modal
    dispatch(setCreateNewReport({ dashboardBaseId: baseId }));
    navigate(url);
  };

  return (
    <>
      <SectionTitle
        {...getToggleProps({
          // Prevent outer menu from closing
          onClick: (e) => e.stopPropagation(),
        })}
      >
        Create New
        <SvgIcon
          name={isExpanded ? 'caret-down-fill' : 'caret-right-fill'}
          width={10}
          height={10}
          customFill="currentColor"
        />
      </SectionTitle>
      <div {...getCollapseProps()}>
        {dashboardSupportedQueryTypes.map((queryType) => {
          const { display, url, icon } = queryTypeConfigLookup[queryType];

          return (
            <StyledOption
              key={`create-new-${queryType}`}
              iconName={icon}
              label={display}
              onClick={() => handleQueryTypeClick(url)}
              disabled={disabled}
            />
          );
        })}
      </div>
    </>
  );
};

export default DashboardAddContentQueryTypes;
